<div class="responsive-card d-flex flex-column gap-4">
  <div class="responsive-card-title" i18n>Age for Minimum Calculation</div>

  <app-system-banner *ngIf="detailsHaveChanged" [banner]="changeBanner" />

  <div class="d-flex flex-column gap-3">
    <div class="d-flex flex-column gap-2">
      <span *ngIf="detailsHaveChanged" class="age-type-label" i18n>Current</span>
      <div class="inner-card" [class.current]="detailsHaveChanged">
        <div class="d-flex flex-column gap-2 flex-grow-1">
          <span class="use-age-label">{{ currentLabel$ | async }}</span>
          <div i18n class="option-details">{{ currentAnnualMinimumDetails?.minimumAgeName }}</div>
        </div>
        <div class="d-flex flex-column gap-2 align-items-end">
          <div class="option-age" i18n>Age: {{ currentAnnualMinimumDetails?.minimumAgeDateOfBirth | age }}</div>
          <div class="justify-content-end option-details" i18n>
            Date of Birth: {{ currentAnnualMinimumDetails?.formattedDateOfBirth }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap-2" *ngIf="detailsHaveChanged">
      <span class="age-type-label" i18n>New (Beginning Jan 1, {{ effectiveYear }})</span>
      <div class="inner-card new">
        <div class="d-flex flex-column gap-2 flex-grow-1">
          <span class="use-age-label">{{ newLabel$ | async }}</span>
          <div i18n class="option-details">{{ newAnnualMinimumDetails?.minimumAgeName }}</div>
        </div>
        <div class="d-flex flex-column gap-2 align-items-end">
          <div class="option-age" i18n>Age: {{ newAnnualMinimumDetails?.minimumAgeDateOfBirth | age }}</div>
          <div class="justify-content-end option-details" i18n>
            Date of Birth: {{ newAnnualMinimumDetails?.formattedDateOfBirth }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
